"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafariLandscapeFullHeightHack = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
require("focus-visible");
const theme_1 = __importDefault(require("./theme"));
const styles = (0, react_1.css) `
    html,
    body,
    #root {
        color: ${theme_1.default.colors.grey90};
        height: 100%;
        min-height: -webkit-fill-available;
    }
    html {
        font-family: ${theme_1.default.text.headingFontFamily}, sans-serif;
        box-sizing: border-box;
    }
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    *,
    *::after,
    *::before {
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-smoothing: antialiased;
    }
    .js-focus-visible .focus-visible {
        outline: none;
        box-shadow: 0 0 1px 3px #76c1ff;
        -webkit-box-shadow: 0 0 1px 3px #76c1ff; /* Blink, Chrome */
        -moz-box-shadow: 0 0 1px 3px #76c1ff; /* Firefox */
    }

    :focus-within input.focus-visible,
    .js-focus-visible :focus:not(.focus-visible) {
        outline: none;
        box-shadow: none;
    }
    :-moz-focusring,
    ::-moz-focus-inner {
        border: 0;
    }
    .ReactModalPortal {
        position: absolute;
        height: 100vh;
    }
`;
exports.SafariLandscapeFullHeightHack = (0, react_1.css) `
    /* %%SAFARIHACK%% okay this is a hack to resolve Safari iOS not respecting height: 100%, and instead forcing us to do 100vh
    Keep it until this known issue gets fixed: https://developers.google.com/web/updates/2016/12/url-bar-resizing
    It works by checking for a landscape device, and the next rule (the @supports bit) is a hack that determines if it is 
    indeed Safari iOS and not Chrome on iOS. This won't work forever, but when it stops working hopefully it won't matter 
    anymore and there will be an official way to do 100% height in landscape that works on all devices/browsers.
    */
    @media (min-height: 324px) and (max-height: 500px) and (orientation: landscape) {
        @supports (background: -webkit-named-image(i)) {
            height: 100vh !important;
        }
    }
`;
const GlobalStyles = () => (0, jsx_runtime_1.jsx)(react_1.Global, { styles: styles });
exports.default = GlobalStyles;
//# sourceMappingURL=global_styles.js.map